import React from "react"
import propTypes from "prop-types"
import "./loading.scss"

const Loading = ({ loading }) => loading ? <div className="loading">loading</div> : null

Loading.propTypes = propTypes.bool.isRequired

export default Loading